import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';


@Injectable({
    providedIn: 'root'
})
export class HighchartsService {
    public static $name = 'clHighchartsService';

    constructor(
    ) {
        this.initialize();
    }

    deepExtend(destination, source) {
        /**
         * Slightly strange behaviour in edge cases (e.g. passing in non objects)
         * But does the job for current use cases.
         */
        if (Array.isArray(source)) {
            destination = Array.isArray(destination) ? destination : [];
            for (var i = 0; i < source.length; i++) {
                destination[i] = this.deepExtend(destination[i] || {}, source[i]);
            }
        } else if (this.isObject(source)) {
            destination = this.isObject(destination) ? destination : {};
            for (var property in source) {
                destination[property] = this.deepExtend(destination[property] || {}, source[property]);
            }
        } else {
            destination = source;
        }
        return destination;
    }

    private isObject(parameter: any) {
        return typeof parameter === 'object' && parameter !== null;
    }

    /**
     * This needs to be run once per client session to ensure the legend appears correctly.
     */
    private configureCheckboxPosition() {
        Highcharts.wrap(Highcharts.Legend.prototype, 'positionCheckboxes', function (p, scrollOffset) {
            // tslint:disable-next-line: one-variable-per-declaration
            var alignAttr = this.group.alignAttr,
                translateY,
                clipHeight = this.clipHeight || this.legendHeight;

            if (alignAttr) {
                translateY = alignAttr.translateY;

                Highcharts.each(this.allItems, function (item) {
                    // tslint:disable-next-line: one-variable-per-declaration
                    var checkbox = item.checkbox,
                        top;

                    if (checkbox) {
                        // tslint:disable-next-line: no-magic-numbers
                        top = (translateY + checkbox.y + (scrollOffset || 0) + 3);
                        Highcharts.css(checkbox, {
                            // tslint:disable-next-line: no-magic-numbers
                            display: top > translateY - 6 && top < translateY + clipHeight - 6 ? '' : 'none',
                            left: checkbox.x + 'px',
                            marginBottom: 0,
                            marginTop: 0,
                            top: top + 'px'
                        });
                    }
                });
            }
        });
    }

    private initialize() {
        this.configureCheckboxPosition();
    }

}
